import { JobApplication, RawApplication } from "../types/application";

/**
 * Maps a raw application response from the API to the JobApplication domain model.
 */
export const mapRawToJobApplication = (raw: RawApplication): JobApplication => ({
  id: raw.applicationId.toString(),
  jobId: raw.job.jobId.toString(),
  jobTitle: raw.job.jobName,
  applicationDate: raw.createdDate,
  currentStatus: raw.status.statusName,
  colorCode: raw.status.colorCode,
  lastUpdated: raw.updatedDate ?? raw.createdDate,
  statusHistory: raw.statusHistory.map((h) => ({
    id: h.historyId.toString(),
    status: h.status.statusName,
    updatedAt: h.createdDate,
    notes: h.remark ?? undefined,
    colorCode: h.status.colorCode,
  })),
});
